"use strict";
// Each consumer scope appends its action strings to this list and ships the
// extension in the same PR that consumes it. The type system narrows the
// argument to @AuditLogged to declared actions only.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUDIT_ACTIONS = void 0;
exports.AUDIT_ACTIONS = [
    'audit_foundation_smoke',
    'kyb_status_manual_override',
    'counterparty_deal_breaker_flags_set',
    'kyb_exception_proposed',
    'kyb_exception_edited',
    'kyb_exception_granted',
    'kyb_exception_rejected',
    'kyb_exception_expired',
    'kyb_document_uploaded',
    'kyb_document_replaced',
    'kyb_document_soft_deleted',
    'kyb_screen_triggered_initial',
    'kyb_screen_triggered_refresh',
    'kyb_screen_triggered_scheduled',
    'kyb_screen_refresh_profile_missing',
    'kyb_outcome_received',
    'kyb_webhook_invalid_signature',
    'kyb_webhook_unparseable',
    'kyb_webhook_profile_id_mismatch',
    'signing_upload_to_pandadoc',
    'signing_send_for_signature',
    'signing_status_reconciled',
    'signing_record_removed',
    'signing_signed_date_override',
    'order_signed_date_changed',
    'invoice_corrected',
    'eligibility_rule_created',
    'eligibility_rule_updated',
    'eligibility_rule_activated',
    'eligibility_rule_deactivated',
    'eligibility_rule_deleted',
    'bl_order_financing_partner_auto_assigned',
    'partner_disqualification_set',
    'partner_disqualification_cleared',
    // LHA — the allocate write
    // path's three actions, over lender_hedge_allocation only.
    'lender_hedge_allocation_created',
    'lender_hedge_allocation_split',
    'lender_hedge_allocation_superseded',
    // LHA — the gated DRAFT->LIVE promotion, added in the same PR that consumes it.
    'lender_hedge_allocation_activated',
    // LHA R5 — the DRAFT-lifecycle backend's edit/soft-delete actions, over
    // lender_hedge_allocation only (same store as create/split/supersede/activate).
    'lender_hedge_allocation_updated',
    'lender_hedge_allocation_deleted',
];
//# sourceMappingURL=audit-actions.js.map